import { render, staticRenderFns } from "./EventReactionDialog.vue?vue&type=template&id=13501026&scoped=true"
import script from "./EventReactionDialog.vue?vue&type=script&lang=js"
export * from "./EventReactionDialog.vue?vue&type=script&lang=js"
import style0 from "./EventReactionDialog.vue?vue&type=style&index=0&id=13501026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13501026",
  null
  
)

export default component.exports